module.exports = __webpack_public_path__ + "img/bg1-1.cfb60f49.png";